import { useBaseViewModel } from '@/common';
import { CourseEntity } from '@/domains/course/entities';
import { CoursePayloadForm } from '@/domains/course/ports/payloads';
import { CreateCourseUsecase, UpdateCourseUsecase } from '@/domains/course/usecases';
import { notification } from 'antd';
import { useState } from 'react';
import { validateCourse } from '../validations';
import { CourseHttpRepository } from '../adapters/repositories';
import { getErrorMessage } from '@/components/hooks/useGetErrorMessage';

export default function CourseFormViewModel(props?: { detailCourse?: CourseEntity }) {
  const createCourseUC = new CreateCourseUsecase(new CourseHttpRepository());
  const updateCourseUC = new UpdateCourseUsecase(new CourseHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseData, setCourseData] = useState<CourseEntity>();

  const actionSaveCourse = async (payload: CoursePayloadForm) => {
    try {
      if (payload.id) {
        const data = await updateCourseUC.run(payload);
        setCourseData(data);
        notification.success({
          message: 'Course Updated',
          description: 'You have successfully updated the course',
          placement: 'bottomRight',
        });
      } else {
        const data = await createCourseUC.run(payload);
        setCourseData(data);
        notification.success({
          message: 'Course Created',
          description: 'You have successfully created a new course',
          placement: 'bottomRight',
        });
      }
      return true;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: getErrorMessage(error),
        placement: 'bottomRight',
      });
      return false;
    }
  };

  const validateForm = (props: { detailCourse: CourseEntity }) => {
    const { schemaCourse } = validateCourse(props);
    return { schemaCourse };
  };

  return {
    loading,
    error,
    courseData,
    actionSaveCourse,
    validateForm,
  };
}
